import 'css-chunksrc/client/pages/planzoneMembersPage/toolbar/sortDropdown/styles.scss';export default {
  "sortDropdown": "_sortDropdown_qnv46_1",
  "title": "_title_qnv46_10",
  "root": "_root_qnv46_16",
  "input": "_input_qnv46_20",
  "opened": "_opened_qnv46_38",
  "icon": "_icon_qnv46_43",
  "listRoot": "_listRoot_qnv46_55",
  "list": "_list_qnv46_55",
  "option": "_option_qnv46_71",
  "selected": "_selected_qnv46_79"
};